import inicioColorido from '../../img/inicio_colorido.svg';
import baseColorido from '../../img/base_colorido.svg';
import resultadoColorido from '../../img/resultado_colorido.svg';
import opcoesColorido from '../../img/opcoes_colorido.svg';
import iconeCentral from '../../img/icone_central.svg';

import inicioColoridoCria from '../../img/inicio_colorido_cria.svg';
import baseColoridoCria from '../../img/base_colorido_cria.svg';
import resultadoColoridoCria from '../../img/resultado_colorido_cria.svg';
import opcoesColoridoCria from '../../img/opcoes_colorido_cria.svg';
import iconeCentralCria from '../../img/icone_central_cria.svg';

const navigationItems = [
  {
    id: 'rebanho',
    labelKey: 'navigation.indices',
    path: '/simulacao_base',
    label: 'Índices',
    shortLabel: 'Índices',
    icon: inicioColorido,
    criaIcon: inicioColoridoCria,
    matches: ['/simulacao_base', '/estoque_animal'],
  },
  {
    id: 'pesos',
    labelKey: 'navigation.weights',
    path: '/calibrar',
    label: 'Pesos',
    shortLabel: 'Pesos',
    icon: baseColorido,
    criaIcon: baseColoridoCria,
    matches: ['/calibrar'],
  },
  {
    id: 'perfil',
    labelKey: 'navigation.profile',
    path: '/perfil',
    label: 'Perfil',
    shortLabel: 'Perfil',
    icon: iconeCentral,
    criaIcon: iconeCentralCria,
    matches: ['/perfil'],
  },
  {
    id: 'financeiro',
    labelKey: 'navigation.finance',
    path: '/resultado_simulacao',
    label: 'Financeiro',
    shortLabel: 'Financeiro',
    icon: resultadoColorido,
    criaIcon: resultadoColoridoCria,
    matches: ['/resultado_simulacao'],
  },
  {
    id: 'simulacoes',
    labelKey: 'navigation.simulations',
    path: '/menu_principal',
    label: 'Simulações',
    shortLabel: 'Simulações',
    icon: opcoesColorido,
    criaIcon: opcoesColoridoCria,
    matches: [
      '/menu_principal',
      '/comparar-sistemas',
      '/sensibilidade',
      '/limite_investimento',
      '/resultado_limite_investimento',
      '/atingir_metas',
      '/resultado_metas',
      '/gera_tabela_produtividade',
    ],
  },
];

export const getNavigationItems = (systemMode) => navigationItems.map((item) => ({
  ...item,
  resolvedIcon: systemMode === 'cria' ? item.criaIcon : item.icon,
}));

export const getBottomNavigationItems = (systemMode) => {
  return getNavigationItems(systemMode);
};

export const isNavigationItemActive = (item, pathname) => item.matches.some((route) => (
  pathname === route || pathname.startsWith(`${route}/`)
));
